import { createStore } from "vuex";
//import AuthService from "./service/auth/auth_service";
import Token from "./utilities/jwt/Token.js";

export default createStore({
  state() {
    return {
      userLogged: null,
      views: {
        login: {
          dialogCreate: false,
          dialogFoggetPassword: false,
        },
        project: {
          dialogForm: false,
          dialogUpload: false,
        },
        folder: {
          dialogList: false,
          dialogForm: false,
          dialogConfig: false,
        },
        file: {
          dialogList: false,
          dialogForm: false,
        },
        users: {
          dialogForm: false,
          dialogChangePassword: false,
        },
        groups: {
          dialogForm: false,
        },
      },
    };
  },
  getters: {
    getUserLogged(state) {
      return state.userLogged;
    },
    getDialogVinculo(state) {
      return state.views.person.dialogFormBond;
    },
  },
  mutations: {
    setUserLogged(state, token) {
      state.userLogged = token;
    },
  },
  actions: {
    setUserLogged({ commit }) {
      commit("setUserLogged", new Token().jwtDecode());
    },
  },
});